import React from 'react';
import { achievements } from '../../Data';

const Pricing = () => {
  const highlight = (title) => {
    const match = title.match(/(\d{1,3}\+|\d{1,3},\d{3}\+|\d{1,3}K\+|\d{1,2}\+ years?)/i);
    return match ? match[0] : null;
  };

  return (
    <section
      id="pricing"
      className="relative overflow-hidden bg-gradient-to-b from-[#070a10] to-[#0b0f17] py-20"
    >
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute -top-24 left-1/2 h-[520px] w-[520px] -translate-x-1/2 rounded-full bg-gradient-to-tr from-accent/20 via-emerald-500/10 to-transparent blur-3xl" />
      </div>

      <div className="max-w-6xl mx-auto px-6 relative">
        <div className="text-center mb-12 md:mb-16">
          <p className="text-xs tracking-[0.22em] uppercase text-gray-400">Achievements</p>
          <h2 className="mt-3 text-3xl md:text-4xl font-bold text-white tracking-tight">
            Impact &amp; Achievements
          </h2>
          <p className="mt-4 text-sm md:text-base text-gray-400 max-w-2xl mx-auto leading-relaxed">
            Key milestones and measurable results.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {achievements.map(({ id, title, description }, idx) => {
            const big = highlight(title);
            const cleanTitle = big ? title.replace(big, '').replace(/^[-–—:\s]+/, '').trim() : title;
            return (
              <article
                key={id}
                className="group relative overflow-hidden rounded-2xl border border-white/10 bg-gradient-to-br from-white/5 to-white/0 p-7 backdrop-blur shadow-soft transition-transform duration-300 hover:scale-[1.02] hover:shadow-xl hover:border-accent/40"
              >
                <div className="pointer-events-none absolute -top-24 -right-24 h-56 w-56 rounded-full bg-accent/10 blur-3xl opacity-0 transition-opacity duration-300 group-hover:opacity-100" />
                <div className="space-y-3">
                  <div className="flex items-baseline gap-3">
                    <div className="text-3xl font-bold text-accent tracking-tight">
                      {big || `${idx + 1}`.padStart(2, '0')}
                    </div>
                    <div className="h-px flex-1 bg-white/10" />
                  </div>
                  <h3 className="text-lg font-semibold text-white tracking-tight">{cleanTitle}</h3>
                  <p className="text-sm text-gray-400 leading-relaxed">{description}</p>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}

export default Pricing
